import * as React from "react";
import { MyCard } from "../MyCard";
import { IReceivedProps, formatNumber } from "./Address";

export function Received({ baseCurrency, received }: IReceivedProps) {
  const receivedAmount = Math.abs(received / 100000000);
  return (
    <MyCard
      header={"Total received · " + (baseCurrency || "TLS")}
      body={formatNumber(receivedAmount)}
    />
  );
}
